
export function getDefaultValue(value,defaultValue){
    return (value != null ? value : (defaultValue == 0 ? defaultValue : ""))
}